export enum VaultsErrorCode {
  CalculateDepositAmountError = 'calculateDepositAmountError',
  CalculateWithdrawAmountError = 'calculateWithdrawAmountError',
  AggregatorError = 'AggregatorError',
  ObjectNotFound = 'ObjectNotFound',
  FetchError = 'FetchError',
  StakeProtocolNotFound = 'StakeProtocolNotFound',
  BuildError = 'BuildError',
  AssertionError = 'AssertionError',
  InvalidMaxFtAmount = 'InvalidMaxFtAmount',
  ConfigError = 'ConfigError',
  MultiplicationOverflow = 'MultiplicationOverflow',
  DivisionByZero = 'DivisionByZero',
  InsufficientCoins = 'InsufficientCoins',
  InvalidParam = 'InvalidParam',
}

export abstract class BaseError extends Error {

  protected constructor(
    message: string,
    public readonly code: string,
    public readonly details?: Record<string, any>
  ) {
    super(message)
    this.name = this.constructor.name
  }

  /**
   * Convert error to JSON format
   */
  toJSON(): Record<string, any> {
    return {
      name: this.name,
      message: this.message,
      code: this.code,
      details: this.details,
    }
  }

  /**
   * Convert error to string format
   */
  toString(): string {
    return JSON.stringify(this.toJSON())
  }

  /**
   * Check if error is instance of specific error code
   */
  static isErrorCode<T extends BaseError>(error: any, code: string): error is T {
    return error instanceof BaseError && error.code === code
  }
}

export class VaultsError extends BaseError {
  constructor(message: string, errorCode?: VaultsErrorCode, details?: Record<string, any>) {
    super(message, errorCode || 'UnknownError', details)
  }
}

export const handleError = (code: VaultsErrorCode, error: Error, details?: Record<string, any>) => {
  throw new VaultsError(error.message, code, details)
}

export const handleMessageError = (code: VaultsErrorCode, message: string, details?: Record<string, any>) => {
  throw new VaultsError(message, code, details)
}
